import { Pipe, PipeTransform } from '@angular/core';
import { Constant } from 'src/constant';

@Pipe({
    name: 'priceFormater'
})
export class PriceFormaterPipe implements PipeTransform {

    constructor() { }

    transform(value: number, params: { language: string, currency: string }) {
        if (!params) {
            throw 'Integration error: no params provided in pipe';
        }
        if (!params.language) {
            throw 'Integration error: no language provided in pipe';
        }
        if (!params.currency) {
            throw 'Integration error: no currency provided in pipe';
        }
        const { language, currency } = params;
        const isCurrencyBeforePrice = Constant.Currencies[currency].displayBeforePrice;
        const fractionDigits = value % 1 ? 2 : 0;
        const formattedValue = value.toLocaleString(language, { minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits });

        if (isCurrencyBeforePrice) {
            return Constant.Currencies[currency].symbol + formattedValue;
        }
        return formattedValue + ' ' + Constant.Currencies[currency].symbol;
    }
}
